import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "polygon",
  "use": "polygon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"polygon\"><path fill=\"#e5e5e5\" d=\"m.758.64 4.23 10.86.733 2.948.087 2.228 16.163 5.051-3.22-11.048 4.04-9.723-10.83 4.017z\" /><path stroke-dasharray=\"4 1\" stroke=\"currentColor\" fill=\"none\" d=\"m.758.64 4.23 10.86.82 5.176 16.163 5.051-3.22-11.048 4.04-9.723-10.695 4.106z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol